import React, { ReactNode } from 'react'

export const defaultTitleEaseSavings = <>Сделать «Сбережение» можно через приложение на телефоне</>

export interface EaseSavingsElement {
	number: number
	title: ReactNode
	desc?: ReactNode
}

export const easeSavingsData: EaseSavingsElement[] = [
	{
		number: 1,
		title: 'Зарегистрируйтесь',
		desc: 'в личном кабинете по номеру телефона',
	},
	{
		number: 2,
		title: 'Подпишите документы',
		desc: <>онлайн не выходя из дома и&nbsp;вступите в&nbsp;кооператив</>,
	},
	{
		number: 3,
		title: 'Переведите сбережение',
		desc: <>и&nbsp;получите доход выше, чем по&nbsp;вкладу в&nbsp;банке</>,
	},
]
